import { fallbackLanguage } from '../config';

// Check if a value is usable for display.
const hasValue = (value) => {
  return value !== undefined && value !== null && String(value).trim() !== '';
};

// Return a translated backend field with safe fallbacks.
export const getTranslatedField = (
  item,
  field,
  selectedLanguage,
  defaultLocale = fallbackLanguage,
) => {
  if (!item || !field) {
    return '';
  }

  const localesToTry = [
    selectedLanguage,
    defaultLocale,
    fallbackLanguage,
    'fr',
    'ar',
    'en',
    'es',
  ].filter(Boolean);

  const uniqueLocales = [...new Set(localesToTry)];

  if (typeof item[field] === 'string' && hasValue(item[field])) {
    return item[field];
  }

  if (item.translations && typeof item.translations === 'object') {
    for (const locale of uniqueLocales) {
      const translatedValue = item.translations?.[locale]?.[field];

      if (hasValue(translatedValue)) {
        return translatedValue;
      }
    }
  }

  if (item[field] && typeof item[field] === 'object') {
    for (const locale of uniqueLocales) {
      const translatedValue = item[field]?.[locale];

      if (hasValue(translatedValue)) {
        return translatedValue;
      }
    }
  }

  for (const locale of uniqueLocales) {
    const translatedValue = item[`${field}_${locale}`];

    if (hasValue(translatedValue)) {
      return translatedValue;
    }
  }

  return '';
};

export default getTranslatedField;